import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';
import logo from '../images/reekariyer.png';
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // Import Firebase authentication

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [user, setUser] = useState(null); // To track user authentication state

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const closeSidebar = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser); // Set the user if logged in, otherwise null
        });
        return () => unsubscribe(); // Cleanup the listener on component unmount
    }, []);

    return (
        <>
            <nav className="navbar">
                <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                    &#9776;
                </button>
                <NavLink className="navbar-brand" to="/">
                    <img src={logo} alt="ReeKariyer" />
                </NavLink>
                <div className={`navbar-nav ${isOpen ? 'show' : ''}`}>
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/hakkinda">Reeder Hakkında</NavLink>
                        </li>
                        {/* Dropdown only for desktop */}
                        <li className="nav-item desktop-only">
                            <NavLink className="nav-link" to="/kesfet">Reeder'ı Keşfet</NavLink>
                            <div className="dropdown-menu">
                                <NavLink className="dropdown-item" to="/reederliningozunden">Reederlının Gözünden</NavLink>
                            </div>
                        </li>
                        <li className="nav-item desktop-only">
                            <NavLink className="nav-link dropdown-toggle" to="#">Reederlı Olmak İçin</NavLink>
                            <div className="dropdown-menu">
                                <NavLink className="dropdown-item" to="/form">İş Başvurusu</NavLink>
                                <NavLink className="dropdown-item" to="/stajbasvuru">Staj Başvurusu</NavLink>
                                <NavLink className="dropdown-item" to="/ilanlar">İş İlanları</NavLink>
                            </div>
                        </li>
                        <li className="nav-item desktop-only">
                            <NavLink className="nav-link dropdown-toggle" to="#">Reederlıyı Neler Bekliyor?</NavLink>
                            <div className="dropdown-menu">
                                <NavLink className="dropdown-item" to="/ikuygulamalari">İK Uygulamaları</NavLink>
                                <NavLink className="dropdown-item" to="/egitimler">Eğitimler</NavLink>
                            </div>
                        </li>
                        {/* Items directly visible on mobile */}
                        <li className="nav-item mobile-only">
                            <NavLink className="nav-link" to="/form">İş Başvurusu</NavLink>
                        </li>
                        <li className="nav-item mobile-only">
                            <NavLink className="nav-link" to="/kesfet">Reeder'ı Keşfet</NavLink>
                        </li>
                        <li className="nav-item mobile-only">
                            <NavLink className="nav-link" to="/reederliningozunden">Reederlının Gözünden</NavLink>
                        </li>
                        <li className="nav-item mobile-only">
                            <NavLink className="nav-link" to="/ikuygulamalari">İK Uygulamaları</NavLink>
                        </li>
                        <li className="nav-item mobile-only">
                            <NavLink className="nav-link" to="/egitimler">Eğitimler</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" activeClassName="active" to={user ? "/hesabim" : "/giris"}>
                                {user ? "Hesabım" : "Giriş Yap"}
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </nav>

            <div className={`navbar-overlay ${isOpen ? 'show' : ''}`} onClick={closeSidebar}></div>
        </>
    );
};

export default Navbar;
